// performance.js
import { Utils } from "./utils.js";
import { Events } from "./events.js";
export function startEventsCounter() {
    console.log("PerformanceMonitor.startEventsCounter()");
}

export const PerformanceMonitor = {
    _metrics: {
        liveToUi: [],
        scrollTime: [],
        eventsPerMinute: 0,
        eventsCount: 0,
        lastEventTs: null
    },

    markLiveEventReceived() {
        this._metrics.lastEventTs = Utils.now();
        this._metrics.eventsCount++;
    },

    markUiUpdated() {
        if (!this._metrics.lastEventTs) return;
        const delta = Utils.now() - this._metrics.lastEventTs;
        this._metrics.liveToUi.push(delta);
        if (this._metrics.liveToUi.length > 100) {
            this._metrics.liveToUi.shift();
        }
    },

    markScroll() {
        const t = Utils.now();
        this._metrics.scrollTime.push(t);
        if (this._metrics.scrollTime.length > 200) {
            this._metrics.scrollTime.shift();
        }
    },

    startEventsCounter() {
        setInterval(() => {
            const count = this._metrics.eventsCount;
            this._metrics.eventsPerMinute = count;
            this._metrics.eventsCount = 0;
            Events.emit("perf:eventsPerMinute", count);
        }, 60000);
    },

    getAverageLiveToUi() {
        const arr = this._metrics.liveToUi;
        if (!arr.length) return null;
        return arr.reduce((a, b) => a + b, 0) / arr.length;
    }
};
